import shaderUtils from "./shaderUtils.js"

const ballshaders = {
  vertexShader: `
varying vec2 vUv; 
varying vec3 vNormal;
varying vec3 vPosition;
varying vec2 vN;

uniform float u_time;
uniform float u_progess;
uniform float pi;
uniform int u_dispFunc;

uniform float u_f1speed;
uniform float u_f1freq;
uniform float u_f1amp;

uniform float u_f2speed;
uniform float u_f2freqy;
uniform float u_f2freqrad;
uniform float u_f2ampy;
uniform float u_f2amprad;

uniform float u_f3speed;
uniform float u_f3freqy;
uniform float u_f3freqrad;
uniform float u_f3ampy;
uniform float u_f3amprad;

uniform float u_f4speed;
uniform float u_f4freq;
uniform float u_f4amp;

uniform vec3 u_bumpPos;
uniform float u_bumpInt;
uniform float u_bumRadius;
uniform float u_bumAmp;

float tangentFactor = 0.005;


${shaderUtils.noise4}

float remap(float value, float low1, float high1, float low2, float high2){
  return low2 + (value - low1) * (high2 - low2) / (high1 - low1);
}

vec3 orthogonal(vec3 v) {
  return normalize(abs(v.x) > abs(v.z) ? vec3(-v.y, v.x, 0.0)
  : vec3(0.0, -v.z, v.y));
}

vec3 func2(vec3 p, float speed, float freqy, float freqrad, float ampy, float amprad){
  vec3 f2out = p; 
  f2out.xz = p.xz*remap(sin(p.y*freqy+u_time*0.001*speed+p.x*2.), -1., 1., 1.-ampy, 1.+ampy);
  float rad = atan(p.x, p.z);
  rad = remap(rad, -pi, pi, 00.,freqrad);
  rad = sin(rad);
  rad = remap(rad, -1., 1., 0., amprad);


  float disp = sin((p.y*freqy+rad));      
  f2out.xz *= remap(disp, 0., 1., 1.-ampy, 1.+ampy);
  return f2out;
}

vec3 bumpyFyFunc(vec3 p, vec3 pOut, vec3 bPos, float bRad, float bInt, float bAmp){
  float dist = distance(bPos, p);
  dist = smoothstep(0.,bRad, dist);
  dist = clamp(dist, 0., 1.);
  dist = 1.-dist;
  dist *= bInt;

  vec3 bump = p*remap(dist, 0.,1.,1., 1.+bAmp);
  return mix(pOut, bump, dist);

}

vec3 distorted(vec3 p) {
  vec3 frame0 = p;
  
  vec3 frame1 = p*(1.+snoise(vec4(p*u_f1freq, u_time*0.0001*u_f1speed))*u_f1amp);

  vec3 frame2 = func2(p,u_f2speed, u_f2freqy, u_f2freqrad,u_f2ampy, u_f2amprad);
  
  vec3 frame3 = func2(p,u_f3speed, u_f3freqy, u_f3freqrad,u_f3ampy, u_f3amprad);

  vec3 frame4 = p*(1.+snoise(vec4(p*u_f4freq, u_time*0.0001*u_f4speed))*u_f4amp);

  vec3 outputP = mix(frame0, frame1, clamp(u_progess, 0.,1.));
  outputP = mix(outputP, frame2, clamp(u_progess-1., 0.,1.));
  outputP = mix(outputP, frame3, clamp(u_progess-2., 0.,1.));
  outputP = mix(outputP, frame4, clamp(u_progess-3., 0.,1.));

  outputP = bumpyFyFunc(p, outputP, u_bumpPos, u_bumRadius, u_bumpInt, u_bumAmp);

  return outputP;
}

void main() {
  vUv = uv; 
  vNormal = normal;
  vPosition = position;

  vec3 dispPos = distorted(position);
  vec3 tangent1 = orthogonal(normal);
  vec3 tangent2 = normalize(cross(normal, tangent1));
  vec3 nearby1 = position + tangent1 * tangentFactor;
  vec3 nearby2 = position + tangent2 * tangentFactor;
  vec3 distorted1 = distorted(nearby1);
  vec3 distorted2 = distorted(nearby2);

  vNormal = normalize(cross(distorted1 - dispPos, distorted2 - dispPos));

  vec4 p = vec4( position, 1. );

  vec3 e = normalize( vec3( modelViewMatrix * p ) );
  vec3 n = normalize( normalMatrix * vNormal );


  vec3 r = reflect( e, n );
  float m = 2. * sqrt(
    pow( r.x, 2. ) +
    pow( r.y, 2. ) +
    pow( r.z + 1., 2. )
  );
  vN = r.xy / m + .5;

  vec4 modelViewPosition = modelViewMatrix * vec4(dispPos, 1.0);
  // vec4 modelViewPosition = modelViewMatrix * vec4(position, 1.0);
  gl_Position = projectionMatrix * modelViewPosition; 
}
  `,
  fragmentShader: `
uniform sampler2D u_matCap;
uniform vec3 u_bumpPos;
uniform float u_bumpInt;
uniform float pi;
uniform float u_op;

varying vec2 vN;
varying vec3 vNormal;
varying vec3 vPosition;
varying vec2 vUv; 


float remap(float value, float low1, float high1, float low2, float high2){
  return low2 + (value - low1) * (high2 - low2) / (high1 - low1);
}


void main() {

  vec4 matCapCol = texture2D(u_matCap, vN);
  matCapCol.a = u_op;

  vec4 outcol = vec4(0.);
  outcol.a = 1.;

  float rad = atan(vPosition.x, vPosition.z);
  rad = remap(rad, -pi, pi, 00.,10.*pi);
  rad = sin(rad);
  rad = remap(rad, -1., 1., 0., 1.);
  // outPoint.xz = outPoint.xz*remap(sin((outPoint.y+rad)*10.), -1., 1., 1.-u_amp2, 1.+u_amp2);


  outcol.rgb = vec3(sin((vPosition.y+rad*0.5)*10.+vPosition.x*10.));
  // outcol.rgb = vec3(rad);

  // gl_FragColor = outcol;
  // gl_FragColor = vec4(vN, 1.,1.);
  gl_FragColor = vec4(matCapCol);
}
  `,
}

export default ballshaders